<template>
  <div class='coursework-viewer__media-area js-coursework-view__media-area'>
    <div class='coursework-viewer__slick-arrow-wrap'>
      <a href="javascript:" class='slick__arrow' v-if="slickReady && currentSlideNumber > 1" @click='prevSlide'>
        <i class='kf kf-arrow-thin kf-flip-horizontal'></i>
      </a>
      <a href="javascript:" class='slick__arrow' v-if="showPrevItemBtn" @click="prevItem">
        <i class='kf kf-arrow-thin kf-rotate-270'></i>
        <div class='slick__arrow-label'>Previous {{subject}}</div>
      </a>
    </div>

    <div class='coursework-viewer__slick-wrapper'>
      <div class='coursework-viewer__spacer-row'></div>

      <div class='coursework-viewer__slide-holder' :style="{visibility: !slickReady ? 'hidden': 'visible'}" ref='slickEl'>
        <empty-slide :subject="subject" v-if="media.length === 0" @ready="slideReady"/>
        <component v-for="obj in media" :is="getSlideName(obj.slide_type)" :media="obj" :key="obj.id" @ready="slideReady"/>
      </div>

      <div class='coursework-viewer__spacer-row'>
        <div class='coursework-viewer__slide-name'>
          <div class='caption' v-if="currentSlide">{{currentSlide.media.description || currentSlide.media.title}}</div>
        </div>
        <div class='coursework-viewer__slide-info'>
          <a href="javascript:" class='slick__arrow' v-if="showPrevItemBtn" @click="prevItem">
            <div class='inline-block-link--light'>Previous {{subject}}</div>
          </a>
          <a href="javascript:" class='slick__arrow' v-if="currentSlideNumber > 1" @click='prevSlide'>
            <i class='kf kf-arrow-thin kf-flip-horizontal'></i>
          </a>
          <template v-if="totalSlideCount > 0">
            <span>{{currentSlideNumber}}</span>
            <span>of</span>
            <span>{{totalSlideCount}}</span>
          </template>
          <a href="javascript:" class='slick__arrow' v-if="currentSlideNumber < totalSlideCount" @click='nextSlide'>
            <i class='kf kf-arrow-thin'></i>
          </a>
          <a href="javascript:" class='slick__arrow' v-if="showNextItemBtn" @click="nextItem">
            <div class='inline-block-link--light'>Next {{subject}}</div>
          </a>
        </div>
      </div>
    </div>

    <div class='coursework-viewer__slick-arrow-wrap'>
      <a href="javascript:" class='slick__arrow' v-if="slickReady && currentSlideNumber < totalSlideCount" @click='nextSlide'>
        <i class='kf kf-arrow-thin'></i>
      </a>
      <a href="javascript:" class='slick__arrow' v-if="showNextItemBtn" @click="nextItem">
        <i class='kf kf-arrow-thin kf-rotate-90'></i>
        <div class='slick__arrow-label'>Next {{subject}}</div>
      </a>
    </div>
  </div>
</template>

<script>
  import audioSlide from './slides/audio.vue'
  import embedSlide from './slides/embed.vue'
  import imageSlide from './slides/image.vue'
  import previewableSlide from './slides/previewable.vue'
  import runnableSlide from './slides/runnable.vue'
  import textSlide from './slides/text.vue'
  import codeSlide from './slides/code.vue'
  import videoSlide from './slides/video.vue'
  import urlSlide from './slides/url.vue'
  import otherSlide from './slides/other.vue'
  import emptySlide from './slides/empty.vue'
  export default {
    props: {
      subject: String,
      navigation: Object,
      media: Array,
      refresh: [Boolean, String]
    },
    data() {
      return {
        slides: [],
        $slider: null,
        slickReady: false,
        readySlides: [],
        currentSlideIndex: 0
      }
    },
    components: {
      audioSlide,
      embedSlide,
      imageSlide,
      previewableSlide,
      runnableSlide,
      textSlide,
      codeSlide,
      videoSlide,
      urlSlide,
      otherSlide,
      emptySlide
    },
    computed: {
      initialSlideIndex() {
        let index = _.findIndex(this.media, (item) => { return item.initial_slide });
        return index > 0 ? index : 0;
      },
      currentSlide() {
        return this.slides[this.currentSlideIndex];
      },
      currentSlideNumber() {
        return this.currentSlideIndex + 1;
      },
      totalSlideCount() {
        return this.media.length;
      },
      showNextItemBtn() {
        return this.navigation && this.navigation.next_url && (this.totalSlideCount === 0 || this.currentSlideNumber === this.totalSlideCount)
      },
      showPrevItemBtn() {
        return this.navigation && this.navigation.prev_url && this.currentSlideNumber === 1
      }
    },
    watch: {
      media() {
        this.destroySlickSlider();
      },
      readySlides() {
        if (this.readySlides.length > 0 && this.readySlides.length === this.slides.length || this.media.length === 0) {
          this.initSlickSlider();
        }
      },
      refresh() {
        this.refreshSlick()
      }
    },
    methods: {
      initSlickSlider() {
        this.$slider = $(this.$refs['slickEl']);

        const options = {
          infinite: false,
          slidesToShow: 1,
          arrows: false,
          dots: false,
          adaptiveHeight: true,
          useCSS: false,
          waitForAnimate: true,
          draggable: false,
          initialSlide: this.initialSlideIndex
        };

        this.$slider.off('afterChange').on('afterChange', (event, slick, currentSlide) => {
          let slideEl = slick.$slides[currentSlide];
          if (_.isEmpty(slideEl)) return;
          this.currentSlideIndex = currentSlide;
          this.$emit('slideChanged', currentSlide)
        });

        this.$slider.off('init').on('init', (event, slick, currentSlide) => {
          this.currentSlideIndex = this.initialSlideIndex;
          this.$emit('slideChanged', this.initialSlideIndex);
          this.$nextTick(function () {
            setTimeout(() => {
              $(window).trigger('resize');
              this.slickReady = true;
              this.$emit('ready');
            }, 300);
          });
        });

        this.$slider.slick(options);
      },
      destroySlickSlider() {
        this.slickReady = false;
        $(this.$slider).slick('unslick');
        _.each(this.slides, (slide) => {
          slide.$destroy();
        });
        this.slides = [];
        this.readySlides = [];
      },
      getSlideName(type) {
        return this.$options.components[s.camelize(type)] ? type : 'other-slide';
      },
      resizeSlideMedia() {
        //Hack to make sure slick slides don't overflow
        let $mediaArea = $('.js-coursework-view__media-area');
        let $media = $('.js-coursework-view__img, .vjs-tech, .js-previewable, .js-previewable-loading');
        $media.css('max-height', $mediaArea.height());

        let $slickList = $('.slick-list');
        let $currentSlide = $('.slick-current');
        $slickList.css('height', $currentSlide.height());
      },
      prevSlide() {
        this.pauseCurrentSlide();
        this.$slider.slick('slickPrev');
      },
      nextSlide() {
        this.pauseCurrentSlide();
        this.$slider.slick('slickNext');
      },
      pauseCurrentSlide() {
        this.currentSlide && this.currentSlide.pause && this.currentSlide.pause()
      },
      slideReady(id) {
        this.readySlides.push(id)
      },
      refreshSlide() {
        //https://github.com/kenwheeler/slick/issues/187
        this.$slider.slick('setPosition');
      },
      refreshSlick() {
        //WARNING: This is very perf intensive, only call as a last resort otherwise use refreshSlide()
        TweenLite.to(this, .5, {
          onUpdate: () => {
            this.$slider.slick('refresh');
          }
        });
      },
      makeRequest: _.memoize((url, loadingIndicator) => {
        return new Kadenze.AjaxRequest({
          type: 'GET',
          url: url,
          loadingIndicator: loadingIndicator
        });
      }),
      nextItem() {
        const response = this.makeRequest(this.navigation.next_url, {container: this.$el, positionTop: 'absolute'});
        response.done((response) => {
          this.$emit('navChanged', response);
        });
      },
      prevItem() {
        const response = this.makeRequest(this.navigation.prev_url, {container: this.$el, positionTop: 'absolute'});
        response.done((response) => {
          this.$emit('navChanged', response);
        });
      },
      bindKeyboardNavEvents() {
        $(document).off('keydown').on('keydown', (e) => {
          if (e.target.className === 'redactor-editor')
            return;

          if(e.keyCode === 37) {
            if (this.currentSlideNumber === 1) {
              this.prevItem()
            } else {
              this.prevSlide()
            }
          } else if (e.keyCode === 39) {
            if (this.slides.length === this.currentSlideNumber) {
              this.nextItem()
            } else {
              this.nextSlide()
            }
          }
        });
      },
    },
    mounted() {
      this.bindKeyboardNavEvents();
      $(window).off('resize').on('resize', () => {
        this.resizeSlideMedia()
      });
    },
    destroyed() {
      this.destroySlickSlider();
    }
  }
</script>